import { render, staticRenderFns } from "./compact-toolbar.vue?vue&type=template&id=43f4b460&"
import script from "./compact-toolbar.vue?vue&type=script&lang=js&"
export * from "./compact-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports